import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
(function (w: any, d: Document, s: string, l: string, i: string) {
  w[l] = w[l] || [];
  w[l].push({
    'gtm.start': new Date().getTime(),
    event: 'gtm.js'
  });
  var f = d.getElementsByTagName(s)[0],
    j = d.createElement(s) as HTMLScriptElement,
    dl = l != 'dataLayer' ? '&l=' + l : '';
  j.async = true;
  j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
  f.parentNode!.insertBefore(j, f);
})(window, document, 'script', 'dataLayer', 'GTM-5R33CHQV');
// Google Tag Manager (noscript) - inject iframe right after opening <body>
const noscript = document.createElement('noscript');
const iframe = document.createElement('iframe');
iframe.src = 'https://www.googletagmanager.com/ns.html?id=GTM-5R33CHQV';
iframe.height = '0';
iframe.width = '0';
iframe.style.display = 'none';
iframe.style.visibility = 'hidden';
noscript.appendChild(iframe);
document.body.insertBefore(noscript, document.body.firstChild);
render(<App data-id="element-343" />, document.getElementById('root'));